/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataClass } from '../models/DataClass';

export class InfectedDataClassificationSize {
  'classification': DataClass;
  /**
  * Size of the infected data in bytes
  */
  'sizeBytes': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "classification",
      "baseName": "classification",
      "type": "DataClass",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return InfectedDataClassificationSize.attributeTypeMap;
  }

  public constructor() {
  }
}



